// removed by extract-text-webpack-plugin
module.exports = {"component":"_2d9I0WTmEVAQOBrmAL5x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/PaymentButton/PaymentButtonMessage/paymentButtonMessage.css
// module id = 1066
// module chunks = 2